// extracted by mini-css-extract-plugin
export default {"examEntryContainer":"ExamEntryModal__examEntryContainer___StY6F"};